import type { MapFeatureCollection, HeatmapFeatureCollection, MapLayersResponse, MapSearchResponse } from "@atlas/shared";
import { apiGet, apiPatch } from "../lib/api-client";

export type {
  FeatureStatus,
  FeatureKind,
  MapFeatureProperties,
  MapFeature,
  MapFeatureCollection,
  MapSearchResult,
  MapSearchResponse,
  HeatmapFeature,
  HeatmapFeatureCollection,
  MapCollectionRef,
  MapLayersResponse,
} from "@atlas/shared";

export function fetchMapFeatures(
  bbox: [number, number, number, number],
  types?: string,
): Promise<MapFeatureCollection> {
  const [w, s, e, n] = bbox;
  const params = new URLSearchParams({ bbox: `${w},${s},${e},${n}` });
  if (types) params.set("types", types);
  return apiGet(`/map/features?${params}`);
}

export function fetchMapSearch(q: string): Promise<MapSearchResponse> {
  return apiGet(`/map/search?${new URLSearchParams({ q })}`);
}

export function fetchHeatmap(): Promise<HeatmapFeatureCollection> {
  return apiGet("/map/heatmap");
}

export type { ExploredCellsResponse } from "@atlas/shared";

/** Spec 13: the user's explored z15 cells (fog-of-war layer + region coverage). */
export function fetchExploredCells(opts?: { region?: string }): Promise<import("@atlas/shared").ExploredCellsResponse> {
  const q = opts?.region ? `?${new URLSearchParams({ region: opts.region })}` : "";
  return apiGet(`/map/explored${q}`);
}

// ─── Map layers (ATL-106) ───────────────────────────────────────────────────
// Per-collection visibility: the exclusion list is stored server-side (syncs
// across web/mobile), applied client-side and display-only.

export const MAP_LAYERS_QUERY_KEY = ["map", "layers"] as const;

export function fetchMapLayers(): Promise<MapLayersResponse> {
  return apiGet("/map/layers");
}

export function updateMapLayers(hidden: string[]): Promise<MapLayersResponse> {
  return apiPatch("/map/layers", { hidden });
}
